import { FC, useEffect, useState } from "react";
import KickImage from 'Reuseables/KickImage';

//Components
import { getShipper, submitAddShippingAddress, submitUpdateShippingAddress, getAreaId } from "../../../../../actions/shipperAction";
import CustomBody from "../../CustomBody/index";
import Component from "./Component";

//Helpers
import { capitalizeSentence } from "../../../../../utils/Helpers";

//Interfaces
import { Field, Form, WrapperInterface } from "./definitions";


const AddPickupAddress: FC<WrapperInterface> = ({
  onBack,
  submitSuccess,
  selectedAddress
}) => {
  const [initField] = useState<Field>({
    value: "",
    errorMsg: "",
    id: null,
    required: true
  })
  const [initForm] = useState<Form>({
    alias: { ...initField },
    full_name: { ...initField },
    phone_number: { ...initField, selectValue: "62" },
    address: { ...initField },
    country: { ...initField, value: "Indonesia" },
    province: { ...initField },
    city: { ...initField },
    suburb: { ...initField },
    area: { ...initField },
    note: { ...initField, required: false },
    postal_code: { ...initField }
  })

  const [formValues, setFormValues] = useState<Form>(initForm);

  const [countries, setCountries] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [suburbs, setSuburbs] = useState([]);
  const [areas, setAreas] = useState([]);
  const [loading, setLoading] = useState(true);

  // HANDLERS SECTION
  const onChangeHandler = (event) => {
    const { name, value } = event.target || {};

    const newFormValues = { ...formValues };
    newFormValues[name] = {
      ...newFormValues[name],
      value
    };
    const removeRelatedValues = (values: string[]) => {
      if (!values?.length) return setFormValues(newFormValues);

      values.forEach((val) => {
        const _initVal = { ...initField };
        newFormValues[val] = _initVal;
      })

      setFormValues(newFormValues);
    }

    switch (name) {
      case "country": {
        removeRelatedValues(["province", "city", "suburb", "area"])
        break;
      }
      case "province": {
        removeRelatedValues(["city", "suburb", "area"])
        break;
      }
      case "city": {
        removeRelatedValues(["suburb", "area"])
        break;
      }
      case "suburb": {
        removeRelatedValues(["area"])
        break;
      }
      default: {
        removeRelatedValues([])
        break;
      };
    }
  }

  const onChangePhoneNumber = (event) => {
    const { name, value } = event.target || {};

    let _value = value;

    if (_value && _value[0] == 0) {
      _value = ""
    }

    const newFormValues = { ...formValues };
    newFormValues[name] = {
      ...newFormValues[name],
      value: _value
    };

    setFormValues(newFormValues);
  }

  const onSelectHandler = ({ name, value }) => {
    const newFormValues = { ...formValues };
    newFormValues[name] = {
      ...newFormValues[name],
      ...value,
      value: value?.name,
      id: value?.id
    };

    const removeRelatedValues = (values: string[]) => {
      if (!values?.length) return setFormValues(newFormValues);

      values.forEach((val) => {
        const _initVal = { ...initField };
        newFormValues[val] = _initVal;
      })

      setFormValues(newFormValues);
    }

    switch (name) {
      case "country": {
        // getShippingHandler(`country/${value.id}/provinces`, "province")
        removeRelatedValues(["province", "city", "suburb", "area"])
        getShippingHandler(`228/province`, "province")
        break;
      }
      case "province": {
        removeRelatedValues(["city", "suburb", "area"])
        getShippingHandler(`${value.id}/city`, "city")
        break;
      }
      case "city": {
        removeRelatedValues(["suburb", "area"])
        getShippingHandler(`${value.id}/suburb`, "suburb")
        break;
      }
      case "suburb": {
        removeRelatedValues(["area"])
        getShippingHandler(`${value.id}/area`, "area")
        break;
      }
      default: {
        removeRelatedValues([])
        break;
      };
    }
  }

  const onSelectPhoneCode = (event) => {
    const { name, value } = event.target;
    const newFormValues = { ...formValues };
    newFormValues[name] = {
      ...newFormValues[name],
      selectValue: value
    };

    setFormValues(newFormValues)
  }

  const initSelectedAddressForm = async () => {
    try {
      setLoading(true)
      await getAreaId(selectedAddress?.area_id)
        .then(res => res?.data?.data || null)
        .then(async (data) => {
          if (!data) return null;
          const newFormValues = { ...formValues };

          //area
          newFormValues[`area`] = {
            ...newFormValues[`area`],
            value: data?.name,
            lat: data?.lat,
            lng: data?.lng,
            id: data?.id,
          }

          for (let val in data) {
            let name = val;
            let value = data[val];
            newFormValues[name] = {
              ...newFormValues[name],
              ...value,
              value: value?.name,
            }

            switch (name) {
              case "country": {
                await getShippingHandler(`${value.id}/province`, "province", true)
                break;
              }
              case "province": {
                await getShippingHandler(`${value.id}/city`, "city", true)
                break;
              }
              case "city": {
                await getShippingHandler(`${value.id}/suburb`, "suburb", true)
                break;
              }
              case "suburb": {
                await getShippingHandler(`${value.id}/area`, "area", true)
                break;
              }
              default: break;
            }
          }

          for (let val in selectedAddress) {
            if (["country", "province", "city", "suburb", "area"].includes(val)) continue;

            let name = val;
            let value = selectedAddress[val]

            if (name === "phone_number" && value && typeof value === "string") {
              value = value.slice(3)
            }

            newFormValues[name] = {
              ...newFormValues[name],
              value
            };
          }

          setFormValues(newFormValues);
        })
        .catch(err => { throw err })
        .finally(() => {
          setLoading(false)
        })
    } catch (err) {
      setLoading(false)
      console.log(err, "Err when init edit form fn initSelectedAddressForm")
    }
  }

  const getShippingHandler = async (url: string, scope: string, oneLoading?: boolean) => {
    try {
      !oneLoading && setLoading(true)
      await getShipper(url + "?limit=9999")
        .then(res => res.data)
        .then(res => {
          if (res?.data && res?.data?.length) {
            return res?.data?.map(datum => {
              const _name = datum?.name?.toLowerCase() ?? ""
              const _value = _name?.toUpperCase()[0] + _name?.slice(1)
              return {
                ...datum,
                value: _value,
                text: _value
              }
            })
          }
          return []
        })
        .then(data => {
          const dataLen = data.length;
          const setNotRequired = (name) => {
            if (dataLen) return null;

            const newFormValues = { ...formValues };
            newFormValues[name] = {
              ...newFormValues[name],
              required: false
            };
          }

          switch (scope) {
            case "country": {
              setCountries(data)
              break;
            }
            case "province": {
              setProvinces(data)
              setNotRequired("province")
              break;
            }
            case "city": {
              setCities(data)
              setNotRequired("city")
              break;
            }
            case "suburb": {
              setSuburbs(data)
              setNotRequired("suburb")
              break;
            }
            case "area": {
              setAreas(data)
              setNotRequired("area")
              break;
            }
            default: break;
          }
        })
        .catch(err => {
          throw err;
        })
        .finally(() => {
          !oneLoading && setLoading(false)
        })
    } catch (err) {
      !oneLoading && setLoading(false)
      console.log(err, "ERROR WHEN FETCHING COUNTRIES")
    }
  }

  const validateInput = () => {
    let error = false;
    const newFormValues = { ...formValues };

    for (let key in newFormValues) {
      if (!newFormValues[key].required) continue;

      if (!newFormValues[key].value) {
        newFormValues[key].errorMsg = `${key} is required`;
        error = true;
      }
    }

    if (error) {
      setFormValues(newFormValues);
      return false;
    }

    return true
  }

  const disableButton = () => {
    let error = false;
    const newFormValues = { ...formValues };

    for (let key in newFormValues) {
      if (!newFormValues[key].required) continue;

      if (!newFormValues[key].value) {
        error = true;
      }
    }

    return error;
  }

  const onSave = async () => {
    try {
      setLoading(true)
      const isValid = validateInput()
      if (!isValid) {
        setLoading(false)
        return null;
      };

      const payload = {
        alias: formValues.alias.value,
        full_name: formValues.full_name.value,
        phone_number: `+${formValues.phone_number.selectValue}${formValues.phone_number.value}`,
        country: capitalizeSentence(formValues.country.value),
        province: formValues.province.value,
        city: formValues.city.value,
        suburb: formValues.suburb.value,
        area_id: formValues.area.id,
        longitude: formValues.area.lng,
        latitude: formValues.area.lat,
        postal_code: formValues.postal_code.value,
        address: formValues.address.value,
        note: formValues.note.value
      }

      const submit = !selectedAddress ? submitAddShippingAddress : submitUpdateShippingAddress;
      const editId = selectedAddress?.id

      await submit(payload, editId)
        .then(res => res?.data)
        .then(res => {
          submitSuccess(res?.data)
        })
        .catch(err => { throw err })
        .finally(() => setLoading(false))
    } catch (err) {
      setLoading(false)
      console.log(err, "Error when try to submit address")
    }
  }

  // USEEFFECT SECTION
  useEffect(() => {
    if (selectedAddress) {
      initSelectedAddressForm()
      return;
    }

    // If need to fetch all countries uncomment this and remove get province
    // getShippingHandler("country", "country")

    getShippingHandler(`228/province`, "province")
  }, [])

  return (
    <CustomBody loading={loading} withBack backAction={onBack}>
      <Component
        provinces={provinces}
        suburbs={suburbs}
        cities={cities}
        areas={areas}
        onChange={onChangeHandler}
        formValues={formValues}
        onSelect={onSelectHandler}
        disabledBtn={disableButton()}
        onSave={onSave}
        onChangePhoneNumber={onChangePhoneNumber}
      />
    </CustomBody>
  )
}
AddPickupAddress.defaultProps = {
  selectedAddress: null,
  onBack: () => { },
  submitSuccess: () => { },
}

export default AddPickupAddress;